const CustomersTab = Object.freeze({
  Animals: "animals",
  Customers: "customers",
});

type CustomersTab = (typeof CustomersTab)[keyof typeof CustomersTab];

export default CustomersTab;
